module.exports = __webpack_public_path__ + "img/mastercard-1kpx.367fe6ad.png";